export const WeeklyInfoContainer = ({ 
	title, 
	children 
}: { 
	title?: string;
	children: React.ReactNode;
}) => {
	return (
		<div className="shop-coin-head__item">
			<div className="shop-coin-head__title">
				<span>{title}</span>
			</div>
			{children}
		</div>
	);
};